import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { KeyTermType } from '@client/graphql/__generated__/types';
import { lowerCase, startCase } from 'lodash';
import { useState } from 'react';
import { useBuyerOfferAnalysisContext } from '../../Context/BuyerOfferAnalysisContext';
import { KeyTermsMobileCard } from './KeyTermsMobileCard';

export const KeyTermsMobileCards = () => {
  const [expandedRow, setExpandedRow] = useState<KeyTermType | null>(null);
  const {
    offerRecs,
    offerRecsLoading,
    agentKeyTerms,
    setAgentKeyTerms,
    buyerOfferAnalysis,
    isViewOnly,
  } = useBuyerOfferAnalysisContext();
  const keyTerms = offerRecs?.keyTerms;
  const buyersAgentUser = buyerOfferAnalysis?.buyersAgent?.user;

  if (!agentKeyTerms || !keyTerms || offerRecsLoading) {
    return <Skeleton height="500px" width="100%" />;
  }

  return (
    <Flex direction="column" gap={3} px={4} width="100%">
      <Text fontSize="lg" fontWeight="medium">
        Offer Details
      </Text>
      {keyTerms?.map((keyTerm) => {
        const keyTermValue = agentKeyTerms[keyTerm.type]?.value;
        const keyTermNotes = agentKeyTerms[keyTerm.type]?.notes;
        const onUpdateValue = (value?: number | null) => {
          setAgentKeyTerms({
            ...agentKeyTerms,
            [keyTerm.type]: { ...agentKeyTerms[keyTerm.type], value },
          });
        };
        const onUpdateNotes = (notes: string | null) => {
          setAgentKeyTerms({
            ...agentKeyTerms,
            [keyTerm.type]: { ...agentKeyTerms[keyTerm.type], notes },
          });
        };
        const hasError = keyTerm.__typename === 'KeyTermError';
        if (hasError) {
          return (
            <KeyTermsMobileCard
              key={keyTerm.type}
              buyersAgentUser={buyersAgentUser}
              errorMessage={keyTerm.reason}
              isExpanded={expandedRow === keyTerm.type}
              isViewOnly={isViewOnly}
              label={keyTerm.label ?? startCase(lowerCase(keyTerm.type))}
              notes={keyTermNotes}
              row={keyTerm.type}
              setExpandedRow={setExpandedRow}
              unit={keyTerm.unit}
              value={keyTermValue}
              onUpdateNotes={onUpdateNotes}
              onUpdateValue={onUpdateValue}
            />
          );
        }

        const confidence =
          keyTerm.context?.source.__typename === 'IndigoOffersSource'
            ? keyTerm.context?.source?.metadata?.confidence
            : undefined;

        const distanceMiles =
          keyTerm.context?.source.__typename === 'IndigoOffersSource'
            ? keyTerm.context?.source?.metadata?.distanceMiles
            : undefined;

        const timePeriodMonths =
          keyTerm.context?.source.__typename === 'IndigoOffersSource'
            ? keyTerm.context?.source?.metadata?.timePeriodMonths
            : undefined;

        return (
          <KeyTermsMobileCard
            key={keyTerm.type}
            buyersAgentUser={buyersAgentUser}
            confidence={confidence}
            distanceMiles={distanceMiles}
            isExpanded={expandedRow === keyTerm.type}
            isViewOnly={isViewOnly}
            label={keyTerm.label ?? startCase(lowerCase(keyTerm.type))}
            marketDataPercentages={keyTerm.context?.marketDataPercentages}
            notes={keyTermNotes}
            range={[
              keyTerm.context?.marketData?.low || 0,
              keyTerm.context?.marketData?.high || 0,
            ]}
            recommendation={keyTerm.recommendation}
            row={keyTerm.type}
            setExpandedRow={setExpandedRow}
            source={keyTerm.context?.source?.type}
            timePeriodMonths={timePeriodMonths}
            unit={keyTerm.unit}
            value={keyTermValue}
            onUpdateNotes={onUpdateNotes}
            onUpdateValue={onUpdateValue}
          />
        );
      })}
    </Flex>
  );
};
